import React, { useState } from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { InfoTooltip } from 'src/App/HOC/Tooltips';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { INFO_BUTTON_COLOR } from 'src/colors';
import { ClickAwayListener } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const InfoButton = ({
  tooltipContent,
  iconColor,
}: {
  tooltipContent: ReactJSXElement;
  iconColor?: string;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));

  if (isMobileDevice) {
    return (
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div>
          <InfoTooltip title={tooltipContent} open={open}>
            <InfoOutlined
              sx={{ fontSize: 16, color: INFO_BUTTON_COLOR, cursor: 'pointer' }}
              onClick={() => setOpen(prev => !prev)}
            />
          </InfoTooltip>
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <InfoTooltip title={tooltipContent}>
      <InfoOutlined
        sx={{ fontSize: 16, color: iconColor ? iconColor : INFO_BUTTON_COLOR, cursor: 'pointer' }}
      />
    </InfoTooltip>
  );
};

export default InfoButton;
